<template>
    <div class="dk-video-modal">
        <div v-if="isLoading" class="dk-video-modal__loading-overlay">
            <loading-spinner :is-loading="isLoading" />
        </div>
        <template v-if="isProviderLa7 || isProviderYoutube">
            <iframe
                :class="`dk-video-modal__iframe-${provider}`"
                :src="getSrc()"
                frameborder="0"
                allow="autoplay; encrypted-media"
                allowfullscreen
                @load="onIframeLoad"
            >
            </iframe>
        </template>
        <template v-else>
            <video
                :src="getSrc()"
                width="100%"
                height="100%"
                autoplay
                controls
                @canplay="onIframeLoad"
            ></video>
        </template>
    </div>
</template>

<script>
import LoadingSpinner from '@v4/common/components/molecules/LoadingSpinner.vue';
import gaEventHandler from '@v4/common/components/mixins/google-analytics.js';

export default {
    name: 'DkVideoModal',
    components: { LoadingSpinner },
    mixins: [gaEventHandler],
    props: {
        provider: {
            type: String,
            default: '',
        },
        videoId: {
            type: String,
            default: '',
        },
        videoUrl: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            isLoading: true,
        };
    },
    computed: {
        isProviderLa7() {
            return this.checkProvider('la7');
        },
        isProviderYoutube() {
            return this.checkProvider('youtube');
        },
    },
    created() {
        this.pushDebounceGaEvent(['video', 'watch', this.videoUrl], 30000);
    },
    methods: {
        onIframeLoad() {
            this.isLoading = false;
        },
        checkProvider(provider) {
            return this.provider.toLowerCase() === provider;
        },
        getSrc() {
            return this.isProviderYoutube
                ? `https://www.youtube.com/embed/${this.videoId}?rel=0&autoplay=1&showinfo=0`
                : this.videoUrl;
        },
    },
};
</script>
